import Box from "@mui/material/Box";
import { FC } from "react";

type IProps = {
  children?: React.ReactNode;
  style?: any;
};

const TitleText: FC<IProps> = ({ children, style }) => {
  return (
    <Box
      sx={[
        {
          fontSize: {
            xs: "14px",
            sm: "16px",
            md: "18px",
          },
          hyphens:'auto'
        },
        style,
      ]}
    >
      {children}
    </Box>
  );
};

export default TitleText;
